var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$store.state.hftype==1?'footer':'footer2', 'modulewrap']},[_c('div',{staticClass:"copyright",domProps:{"innerHTML":_vm._s(_vm.$common.langinfo(_vm.footerinfo.content,_vm.footerinfo.content_en).replace('@@','&copy;'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }